<div class="region-tree-container" *ngIf="regionTree" #treeContainer>
  <svg class="connectors-layer" *ngIf="connectors.length" [attr.width]="containerWidth" [attr.height]="containerHeight">
    <line *ngFor="let c of connectors; trackBy: trackLine"
          [attr.x1]="c.x1" [attr.y1]="c.y1" [attr.x2]="c.x2" [attr.y2]="c.y2"
          stroke="#cbd5e1" stroke-width="2" stroke-linecap="butt" stroke-linejoin="round" shape-rendering="geometricPrecision" />
  </svg>
  <div #wrapper
       class="tree-content-wrapper"
       [style.zoom]="treeScale"
       style="transform-origin: top left; position: relative;">
    <div class="tree-level">
      <div class="node-wrapper"
           [attr.data-region-id]="regionTree.id"
           (click)="$event.stopPropagation(); onNodeClick(regionTree.id)"
           (mouseenter)="showTooltip($event, regionTree.id)"
           (mouseleave)="hideTooltip()"
           (focusin)="showTooltip($event, regionTree.id)"
           (focusout)="hideTooltip()">
        <div class="node" [class.selected]="selectedNodeIds.includes(regionTree.id)" tabindex="0">
          <div class="region-header">Region {{ regionTree.id }}</div>
          <img *ngIf="imageMap[regionTree.id]" [src]="imageMap[regionTree.id]" class="chart-thumb-img" />
          <div *ngIf="!imageMap[regionTree.id]" class="chart-generator">
            <div echarts [options]="optionsMap[regionTree.id]" [initOpts]="{ renderer: 'canvas', width: 300, height: 200 }" (chartInit)="onChartInit($event, regionTree.id)"></div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="levelTpl; context: { nodes: regionTree.children }"></ng-container>
  </div>

  <div class="reset-button-container">
    <button (click)="resetSelection()" class="reset-button">Reset Selection</button>
  </div>
</div>

<ng-template #levelTpl let-nodes="nodes">
  <div class="tree-level" *ngIf="nodes && nodes.length > 0">
    <div *ngFor="let node of nodes" 
         class="node-wrapper" 
         [attr.data-region-id]="node.id"
         (click)="$event.stopPropagation(); onNodeClick(node.id)"
         (mouseenter)="showTooltip($event, node.id)"
         (mouseleave)="hideTooltip()"
         (focusin)="showTooltip($event, node.id)"
         (focusout)="hideTooltip()"
         [style.--tree-scale]="treeScale">
      <div class="node" [class.selected]="selectedNodeIds.includes(node.id)" tabindex="0">
        <div class="region-header">Region {{ node.id }}</div>
        <img *ngIf="imageMap[node.id]" [src]="imageMap[node.id]" class="chart-thumb-img" />
        <div *ngIf="!imageMap[node.id]" class="chart-generator">
          <div echarts [options]="optionsMap[node.id]" [initOpts]="{ renderer: 'canvas', width: 300, height: 200 }" (chartInit)="onChartInit($event, node.id)"></div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="levelTpl; context: { nodes: node.children }"></ng-container>
    </div>
  </div>
</ng-template>

<div *ngIf="activeTooltip as t"
     id="rt-tooltip"
     class="global-region-tooltip"
     [style.top.px]="t.top"
     [style.left.px]="t.left"
     [attr.data-placement]="t.placement"
     role="tooltip"
     (mouseenter)="hideTooltip()">
  <ng-container *ngIf="metricsByRegion[t.regionId] as met">
    <div class="tooltip-title">Region {{ t.regionId }}</div>
    <div class="tooltip-line"><span>Code Lines:</span> {{ regionDetailsMap[t.regionId].lines }}</div>
    <div class="tooltip-line"><span>% Exec:</span> {{ met.executionRange[0] | number:'1.1-1' }}% – {{ met.executionRange[1] | number:'1.1-1' }}%</div>
    <div class="tooltip-line"><span>Time Var:</span> {{ met.timeVariationRange[0] | number:'1.1-1' }}% – {{ met.timeVariationRange[1] | number:'1.1-1' }}%</div>
  </ng-container>
</div>
